import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { v4 as uuidv4 } from 'uuid';
import isEmpty from 'lodash/isEmpty';
import tips_icon from 'assets/img/tips.jpg';
import equalizer_icon from 'assets/img/equalizer.svg';

import Dropzone from 'react-dropzone';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';

import { Dropdown } from 'components/Dropdown/Dropdown';
import { Popup } from 'components/Popup/popup';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { Input, TextArea } from 'components/ValidationInput';

import * as ProjectActionType from 'Projects/constants';
import * as WorkOrderActionType from 'Work-Orders/constants';
import * as SubcontractorActionType from 'Subcontractors/constants';

import * as ModelActionType from 'Model/constants';
import * as Vali from 'helper/validator-helper';
import './bulk-mail.scss';
import { AppSettings } from '../constants';

const MAXIMUM_FILE_SIZE = 1024 * 1024 * 10;

export const BUILDER_USERS = [{ value: 0, text: 'All users' }];

export const SUB_PROJECTS = [{ value: 0, text: 'All projects' }];

export const SUB_COMPANIES = [{ value: 0, text: 'All companies' }];

export const HOMEOWNER_PLANS = [{ value: 0, text: 'All plans' }];

const savedFilterStyle = {
  width: 250,
  left: '160px',
  top: '7px',
};

class BulkMailBuilder extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    user: PropTypes.object,
    mode: PropTypes.string,
    hidden: PropTypes.bool,
    MediaList: PropTypes.object,
    mediaId: PropTypes.string,
    MediaCategories: PropTypes.array,
    SelectListRegions: PropTypes.array,
    ProjectList: PropTypes.array,
    CheckCopiedProject: PropTypes.object,
    ListCheckCopiedRegion: PropTypes.array,
    ProjectStore: PropTypes.object,
    ModelStore: PropTypes.object,
    WorkOrderCredentials: PropTypes.object,
    SubcontractorStore: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.AWSCredential = null;
    this.state = {
      cancelUploadList: {},
      deleteUploadList: {},
      disableEdit: true,

      showSubConfigPopup: false,

      subSelected: null,
      subType: 'project',
      subTitle: 'by project',

      builderSelected: null,
      homeOwnerSelected: null,
      planSelected: HOMEOWNER_PLANS[0],

      subSendToCompanyEmail: false,
      subSendToOwnerEmail: false,
      subSendToContactPoints: true,

      files: [],
      errorFile: null,

      reportIds: [],
    };
  }

  componentDidMount() {
    this.getProjectList();
    this.getSubcontractorList();

    document.addEventListener(
      'mousedown',
      (e) => {
        this.hideSubConfigPoupWhenClickOutside(e);
      },
      false
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ProjectStore.ManageProjects) {
      let projects = [...SUB_PROJECTS];

      nextProps.ProjectStore.ManageProjects.items.map((x) =>
        projects.push({ value: x.id, text: x.name })
      );
      this.setState({ projectList: projects });
    }

    if (nextProps.ModelStore) {
      let plans = [...HOMEOWNER_PLANS];

      nextProps.ModelStore.items.map((x) =>
        plans.push({ value: x.id, text: x.name })
      );
      this.setState({ planList: plans });
    }

    if (nextProps.SubcontractorStore.ManageSubcontractor) {
      let companies = [...SUB_COMPANIES];

      nextProps.SubcontractorStore.ManageSubcontractor.items.map((x) =>
        companies.push({ value: x.subcontractorId, text: x.subcontractorName })
      );
      this.setState({ companyList: companies });
    }
  }

  getSubcontractorList = () => {
    this.props.dispatch({
      type: SubcontractorActionType.SEARCH_SUBCONTRACTOR_ASYNC,
      params: {
        searchKey: '',
        sortField: 'subcontractorName',
        sortOrder: 'ascending',
        status: 1,
        skip: 0,
        take: 1000,
      },
    });
  };

  getModelList = () => {
    this.props.dispatch({
      type: ModelActionType.SEARCH_MODEL_ASYNC,
      params: {
        searchKey: '',
        projectId: this.state.homeOwnerSelected.value, // project id
        sortField: 'name',
        sortOrder: 'ascending',
        skip: 0,
        take: 1000,
      },
    });
  };

  getProjectList = () => {
    this.props.dispatch({
      type: ProjectActionType.SEARCH_PROJECT_ASYNC,
      params: {
        searchKey: '',
        sortField: 'name',
        sortOrder: 'ascending',
        skip: 0,
        take: 1000,
      },
    });
  };

  hideSubConfigPoupWhenClickOutside = (e) => {
    if (e) {
      if (
        this.subConfigButtonRef &&
        !this.subConfigButtonRef.contains(e.target)
      ) {
        this.setState({ showSubConfigPopup: false });
      }
    } else {
      this.setState({ showSubConfigPopup: false });
    }
  };

  onClickSubConfigIcon = () => {
    this.setState({ showSubConfigPopup: !this.state.showSubConfigPopup });
  };

  onClickSubCheckbox = (e, value, status) => {
    this.setState({ [value]: status.checked });
  };

  onChangeBuilderDropdown = (e) => {
    this.setState({ builderSelected: e.value });
  };

  onChangeSubDropdown = (e) => {
    this.setState({ subSelected: e.value });
  };

  onChangeHomeownerDropdown = (e) => {
    this.setState(
      {
        homeOwnerSelected: e.value,
        showPlanList: e.value !== null && e.value.value !== 0,
        planSelected:
          e.value !== null && e.value.value !== 0
            ? this.state.planSelected
            : HOMEOWNER_PLANS[0],
      },
      () => {
        if (e.value !== null && e.value.value !== 0) {
          this.getModelList();
        }
      }
    );
  };

  onChangePlanDropdown = (e) => {
    this.setState({ planSelected: e.value });
  };

  onTextInputChange = (inputName, obj) => {
    let hasError = false;

    if (!this.textInputs) {
      this.textInputs = {};
    }

    this.textInputs[inputName] = obj;

    for (let key in this.textInputs) {
      if (this.textInputs[key].error) {
        hasError = true;
        break;
      }
    }

    this.setState({ hasError: hasError });
  };

  renderSendEmailToPopup = () => {
    return (
      <Popup
        id='send-email-to-popup'
        className='send-email-to-popup'
        styles={savedFilterStyle}
      >
        <div style={{ padding: '10px 10px 5px 5px' }}>
          <p>Send emails to</p>

          <CheckBoxSingle
            checked={this.state.subSendToCompanyEmail}
            value='subSendToCompanyEmail'
            label='Company email addresses'
            className='checkbox-default noteTitle'
            onChecked={this.onClickSubCheckbox}
          />

          <CheckBoxSingle
            checked={this.state.subSendToOwnerEmail}
            value='subSendToOwnerEmail'
            label='Super admin email addresses'
            className='checkbox-default noteTitle'
            onChecked={this.onClickSubCheckbox}
          />

          <CheckBoxSingle
            checked={this.state.subSendToContactPoints}
            value='subSendToContactPoints'
            label='Contact points'
            className='checkbox-default noteTitle'
            onChecked={this.onClickSubCheckbox}
          />
        </div>
      </Popup>
    );
  };

  changeAttachmentType = (e) => {
    this.setState({
      // uploadType: e.currentTarget.name,
      uploadTitle:
        e.currentTarget.name === 'file' ? 'File upload' : 'My reports',
    });
  };

  changeSubType = (e) => {
    this.setState({
      subSelected: null,
      subType: e.currentTarget.name,
      subTitle:
        e.currentTarget.name === 'project'
          ? 'by project'
          : 'by individual company',
    });
  };

  renderMyReportCheckList = () => {
    return (
      <div>
        <CheckBoxSingle
          checked={this.state.mrOpenWarranty}
          value='mrOpenWarranty'
          label='Open warranty work orders'
          className='checkbox-default noteTitle'
          onChecked={this.onClickSubCheckbox}
        />

        <CheckBoxSingle
          checked={this.state.mrPastDue}
          value='mrPastDue'
          label='Past due work orders'
          className='checkbox-default noteTitle'
          onChecked={this.onClickSubCheckbox}
        />
      </div>
    );
  };

  onSelectedAttachments = (droppedFiles) => {
    const { files } = this.state;

    //check maximum upload file is 5
    if (files.length + droppedFiles.length > 5) {
      this.setState({ errorFile: 'Maximum 5 files allowed.' });
    } else {
      let errorFile = null;
      let currentFiles = [...files];

      // show error message when total upload size exceed 10MB
      let totalSize = currentFiles.reduce((t, f) => t + f.size, 0);
      totalSize = droppedFiles.reduce((t, f) => t + f.size, totalSize);

      if (totalSize > MAXIMUM_FILE_SIZE) {
        errorFile = 'Maximum total attachment size is 10MB';
      } else {
        droppedFiles.map((file) => {
          file['id'] = uuidv4();
          currentFiles.push(file);
        });
      }

      this.setState({
        files: currentFiles,
        errorFile: errorFile,
      });
    }
  };

  sendEmail = (uploadedFiles = []) => {
    const params = {
      subject: this.textInputs.subject.value,
      message: this.textInputs.message.value,

      builderSelected: this.state.builderSelected
        ? this.state.builderSelected.value
        : null,
      subSelected: {
        subType: this.state.subType === 'project' ? 0 : 1,
        itemId: this.state.subSelected ? this.state.subSelected.value : null,
        subSendToCompanyEmail: this.state.subSendToCompanyEmail,
        subSendToOwnerEmail: this.state.subSendToOwnerEmail,
        subSendToContactPoints: this.state.subSendToContactPoints,
      },
      homeOwnerSelected: {
        projectId: this.state.homeOwnerSelected
          ? this.state.homeOwnerSelected.value
          : null,
        planId: this.state.planSelected.value,
      },

      // attachmentType: this.state.uploadType,
      // reportIds: this.state.reportIds,
      files: uploadedFiles.map((f) => ({
        url: f.Location,
        key: f.Key,
        fileName: f.name,
      })),
    };

    this.props.dispatch({
      type: WorkOrderActionType.SEND_BULK_MAIL_ASYNC,
      params: params,
      callback: () => {
        window.location.reload();
      },
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (isEmpty(this.state.files)) {
      this.sendEmail();
    } else {
      this.uploadAttachmentsToS3(this.state.files, this.sendEmail);
    }
  };

  onClickTrashIcon = (selectedFile) => {
    let currentFiles = [
      ...this.state.files.filter((f) => f.id !== selectedFile.id),
    ];

    this.setState({
      files: currentFiles,
      errorFile: null,
    });
  };

  uploadAttachmentsToS3 = (files, callback) => {
    let uploadedFiles = [];

    this.props.dispatch({
      type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
      params: { resourcePath: 'bulk-mail' },
      callback: () => {
        files.map((file) => {
          this.props.dispatch({
            type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
            params: {
              file: file,
              config: this.props.WorkOrderCredentials,
            },
            callback: (status, result) => {
              if (status === true) {
                result.data.name = file.name;
                uploadedFiles.push(result.data);

                if (uploadedFiles.length === files.length) {
                  callback(uploadedFiles);
                }
              }
            },
          });
        });
      },
    });
  };

  getFileSize = (fileSize) => {
    const megaByte = 1024 * 1024;

    if (fileSize > megaByte) {
      return Math.round((fileSize / megaByte) * 10) / 10 + ' MB';
    }

    return Math.round((fileSize / 1024) * 10) / 10 + ' KB';
  };

  renderDropZone = () => {
    return (
      <React.Fragment>
        <div className='row' style={{ marginTop: '20px' }}>
          <Dropzone
            disableClick
            ref={(node) => {
              this.dropzoneRef = node;
            }}
            onDrop={this.onSelectedAttachments}
            className='media-library-dropzone col-sm-3'
            style={{ marginBottom: '20px' }}
          >
            <div className='upload-block'>
              <span className='files-upload-ic'>
                <i className='fa fa-cloud-upload' />
              </span>
              Drag files here or{' '}
              <span
                className='files-browse-txt'
                onClick={() => {
                  this.dropzoneRef.open();
                }}
              >
                browse.
              </span>
            </div>
          </Dropzone>
          <div
            className='col-xs-12 col-sm-3 col-md-2 col-md-offset-1'
            style={{ textAlign: 'center' }}
          >
            <img src={tips_icon} style={{ maxWidth: '100px' }} />
          </div>
          <div
            className='col-xs-10 col-xs-offset-1 col-sm-offset-0 col-sm-5 col-lg-3'
            style={{
              border: '2px dashed #777777',
              textAlign: 'justify',
              borderRadius: '10px',
              maxWidth: '310px',
              padding: '10px',
              backgroundColor: '#FFD766',
            }}
          >
            <p style={{ fontSize: '12px' }}>
              Attachments are in and of themselves potential risks when sending
              email. Email filters are more likely to prevent delivery of a
              message that has an attachment due to the risk of viruses.
            </p>
            <p style={{ fontSize: '12px' }}>
              A good alternative to attaching a file to your message is to place
              it on a page of your website, and then provide a link to that web
              page within your message body.
            </p>
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-6'>
            {this.state.errorFile && (
              <div
                className='text-danger'
                style={{ fontSize: '12px', marginBottom: '5px' }}
              >
                {this.state.errorFile}
              </div>
            )}
            {this.state.files.map((f) => (
              <div key={f.name} style={{ marginBottom: '5px' }}>
                <span style={{ fontStyle: 'italic' }}>
                  {f.name} ({this.getFileSize(f.size)})
                </span>
                <i
                  className='fa fa-trash'
                  style={{ cursor: 'pointer', marginLeft: 15 }}
                  onClick={() => this.onClickTrashIcon(f)}
                />
              </div>
            ))}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    return (
      <div id='manage-media-libraries'>
        {AppSettings.clientTypeValue === 'Builder' ? (
          <div className='page-title clearfix'>
            <h2 className='pull-left'>Project Buzz</h2>
          </div>
        ) : (
          <div className='page-title clearfix'>
            <h2 className='pull-left'>Bulk Mail</h2>
          </div>
        )}
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xs-3 box-form-siteone'>
              <p>Recipients</p>

              <div className='form-group'>
                <label>Builder users</label>
                <Dropdown
                  name='builder_users'
                  style={{ width: '100%' }}
                  optionLabel='text'
                  className='filestring-dropdown'
                  placeholder='Please select'
                  showClear={true}
                  options={BUILDER_USERS}
                  value={this.state.builderSelected}
                  onChange={this.onChangeBuilderDropdown}
                />
              </div>

              <div className='form-group'>
                <label style={{ paddingRight: '10px' }}>Subcontractors</label>
                <div
                  className='dropdown'
                  style={{ display: 'block', marginBottom: '10px' }}
                >
                  <a
                    href='#'
                    className='dropdown-toggle'
                    data-toggle='dropdown'
                    style={{ color: 'black', fontWeight: 'bold' }}
                  >
                    {this.state.subTitle}
                    <span
                      className='caret'
                      style={{ marginBottom: '2px', marginLeft: '5px' }}
                    />
                  </a>
                  <ul className='dropdown-menu' style={{ marginTop: 3 }}>
                    <li>
                      <a href='#' name='project' onClick={this.changeSubType}>
                        by project
                      </a>
                    </li>
                    <li>
                      <a href='#' name='company' onClick={this.changeSubType}>
                        by individual company
                      </a>
                    </li>
                  </ul>
                  <div
                    style={{ float: 'right' }}
                    ref={(ref) => {
                      this.subConfigButtonRef = ref;
                    }}
                  >
                    <div style={{ width: 20, cursor: 'pointer' }}>
                      <img
                        className='icon'
                        src={equalizer_icon}
                        onClick={this.onClickSubConfigIcon}
                      />
                      {this.state.showSubConfigPopup &&
                        this.renderSendEmailToPopup()}
                    </div>
                  </div>
                </div>

                <Dropdown
                  name='subcontractor_items'
                  style={{ width: '100%' }}
                  className='filestring-dropdown'
                  optionLabel='text'
                  placeholder='Please select'
                  showClear={true}
                  options={
                    this.state.subType === 'project'
                      ? this.state.projectList
                      : this.state.companyList
                  }
                  value={this.state.subSelected}
                  onChange={this.onChangeSubDropdown}
                />
              </div>

              <div className='form-group'>
                <label>Homeowners by project</label>
                <Dropdown
                  name='homeowner-user'
                  style={{ width: '100%' }}
                  className='filestring-dropdown'
                  showClear={true}
                  optionLabel='text'
                  placeholder='Please select'
                  options={this.state.projectList}
                  value={this.state.homeOwnerSelected}
                  onChange={this.onChangeHomeownerDropdown}
                />
              </div>

              {this.state.showPlanList && (
                <div className='form-group'>
                  <label>Plans</label>
                  <Dropdown
                    name='plan-user'
                    style={{ width: '100%' }}
                    className='filestring-dropdown'
                    optionLabel='text'
                    placeholder='Please select'
                    options={this.state.planList}
                    value={this.state.planSelected}
                    onChange={this.onChangePlanDropdown}
                  />
                </div>
              )}
            </div>
            <div className='col-xs-9' style={{ paddingRight: 0 }}>
              <div
                className='box-form-siteone clearfix'
                style={{ paddingLeft: '15px', paddingRight: '15px' }}
              >
                <Form
                  ref={(ref) => {
                    this.form = ref;
                  }}
                  onSubmit={this.onSubmit}
                >
                  <p>Compose email</p>
                  <div className='form-group'>
                    <label htmlFor='subject'>
                      Subject<span className='text-danger'> *</span>
                    </label>
                    <Input
                      type='text'
                      name='subject'
                      initValue={
                        this.textInputs &&
                        this.textInputs.subject &&
                        this.textInputs.subject.value
                      }
                      onChange={(v) => this.onTextInputChange('subject', v)}
                      validators={[Vali.required]}
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='message'>Message</label>
                    <TextArea
                      name='message'
                      rows={5}
                      initValue={
                        this.textInputs &&
                        this.textInputs.message &&
                        this.textInputs.message.value
                      }
                      onChange={(v) => this.onTextInputChange('message', v)}
                    />
                  </div>
                  <span>Attachments </span>
                  {/* <div className='dropdown' style={{display: 'inline-block'}}>
                    <a href='#' className='dropdown-toggle' data-toggle='dropdown' style={{color: 'black', fontWeight: 'bold'}}>
                      {this.state.uploadTitle}<span className='caret' style={{marginBottom: '2px', marginLeft: '5px'}} />
                    </a>
                    <ul className='dropdown-menu' style={{marginTop: 3}}>
                      <li><a href='#' name='file' onClick={this.changeAttachmentType}>File upload</a></li>
                      <li><a href='#' name='report' onClick={this.changeAttachmentType}>My reports</a></li>
                    </ul>
                  </div> */}
                  {/* {this.state.uploadType === 'file' && this.renderDropZone()} */}
                  {this.renderDropZone()}
                  {/* {this.state.uploadType === 'report' && this.renderMyReportCheckList()} */}
                  <Submit
                    disabled={this.state.hasError}
                    className='btn btn-primary btn-siteone'
                    style={{ marginTop: '20px' }}
                  >
                    Send
                  </Submit>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ProjectStore: state.ProjectStore,
    ModelStore: state.ModelStore.ManageModels,
    SubcontractorStore: state.SubcontractorStore,
    WorkOrderCredentials: state.WorkOrderReducer.Credentials,
  };
};

export default connect(mapStateToProps)(BulkMailBuilder);



// WEBPACK FOOTER //
// ./src/BulkMail/bulk-mail-builder.js